/*
 * Cliques em links: cada clique num link externo de uma
 * postagem é contado, e o número aparece ao lado do link (`span.badge.clicks`,
 * a partir de 1 clique). Os "Links populares" ficam no mapa do tópico
 * (TopicMap) e os "Melhores links" no resumo do perfil.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import { discussionLinks, isExternalUrl, linksEnabled, trackClick } from './data';
import { t } from '../../utils/settings';
import { formatViews } from '../../utils/views';
export { discussionLinks, linksEnabled, trackClick } from './data';
const BADGE = 'CanelaLinkClicks';
export default function installLinks() {
  installTracker();
  installBadges();
}

/**
 * Um ouvinte só, no documento: os posts entram e saem da página o tempo todo
 * (a rolagem do PostStream), e um ouvinte por link teria de acompanhar isso.
 * `auxclick` pega o botão do meio (abrir em outra aba), que também conta.
 */
function installTracker() {
  const onClick = event => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (!linksEnabled()) return;
    const anchor = event.target?.closest?.('a[href]');
    const body = anchor?.closest('.Post-body');
    const href = anchor?.getAttribute('href') ?? null;
    if (!anchor || !body || anchor.closest(`.${BADGE}`) || !isExternalUrl(href)) return;
    const item = body.closest('.PostStream-item[data-id], .PostList [data-id]');
    const postId = item?.dataset.id;
    if (!postId) return;
    const post = app.store.getById('posts', postId);
    trackClick(postId, href, post?.discussion() || null);

    // O post não redesenha por causa disso (o Post do core só se refaz quando
    // ele muda): o número novo entra direto no DOM.
    if (post) decorateBody(body, post);
  };
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
}

/**
 * O número fica DENTRO do elemento que já tem o link (o <p>, o <li>), logo
 * depois do <a>: o post entra com m.trust, e um nó novo no nível de cima
 * atrapalharia o Mithril a remover esse HTML quando o post muda.
 */
function installBadges() {
  extend(CommentPost.prototype, ['oncreate', 'onupdate'], function () {
    const body = this.element?.querySelector?.('.Post-body');
    const post = this.attrs?.post;
    if (body && post) decorateBody(body, post);
  });
}

/** Põe, atualiza ou tira o número ao lado de cada link do post. */
export function decorateBody(body, post) {
  const counts = discussionLinks(post.discussion())?.posts[String(post.id())];
  if (!counts && !body.querySelector(`.${BADGE}`)) return;
  body.querySelectorAll('a[href]').forEach(anchor => {
    if (anchor.parentElement === body || anchor.closest(`.${BADGE}`)) return;
    const href = anchor.getAttribute('href') || '';
    const clicks = counts?.[href] || 0;
    const next = anchor.nextElementSibling;
    const badge = next?.classList.contains(BADGE) ? next : null;
    if (clicks < 1) {
      badge?.remove();
      return;
    }
    const label = t('links.clicks', {
      count: clicks
    });
    // O número abreviado: 1,2 mil, 120 mil.
    const text = formatViews(clicks);
    if (badge) {
      if (badge.textContent !== text) badge.textContent = text;
      badge.title = label;
      return;
    }
    const span = document.createElement('span');
    span.className = `badge clicks ${BADGE}`;
    span.title = label;
    span.setAttribute('aria-label', label);
    span.textContent = text;
    anchor.after(span);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/links', installLinks);